import { createSelector } from 'reselect';
import { get as _get } from 'lodash';

import { status } from './constants';

const selectFiles = state => state.files;

const selectNameProp = (_, poolName) => poolName;

export const selectFileList = createSelector(selectFiles, selectNameProp, (files, poolName) =>
    _get(files, poolName, []),
);

export const selectUploadedFiles = createSelector(selectFileList, files =>
    files.filter(item => item.status === status.DONE),
);
